import { TaskErrorsService } from './taskErrors';

export const TaskErrorsServiceSingleton = new TaskErrorsService();
